module.exports = __webpack_public_path__ + "5a977a03e78081bf5aa8b75b5e69f05e.jpg";